module.exports = __webpack_public_path__ + "media/photo/AdobeStock_249148689-880ba7a6.jpg";